<div class="d-flex justify-content-start">
    <div class="d-flex justify-content-start" *ngFor="let list of breadCrumbList; let i = index">
        <div *ngIf="breadCrumbList?.length-1 != i" class="d-flex justify-content-start">
            <div (click)="changeRootPerson(list)" [ngClass]="breadCrumbList?.length === i+2 ? 'breadcrumb-active' : 'breadcrumb-default'" 
            class="p-2 bd-highlight element-over-hand" >
            {{this.breakText(list.DisplayName,0)}}
            </div>
            <div  *ngIf="breadCrumbList?.length > i+2" [ngClass]="breadCrumbList?.length === i+3 ? 'divider-active' : 'divider-default'"></div>
        </div>
    </div>
</div>
